module.exports = __webpack_public_path__ + "slide-3-7do.jpg";